import { Dialog, Flex, Heading, IconButton, Link, Text } from '@radix-ui/themes';
import { TbExternalLink, TbX } from 'react-icons/tb';
import Styles from './css/releases-modal.module.scss';
import { getReleaseType, getReleaseTypeIcon } from './helpers/releaseTypes';
import { releaseItems } from './releaseItems';

export function ReleasesModal({
  open,
  setOpen,
  usersPreviousReleasesPosition,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  usersPreviousReleasesPosition: number;
}) {
  const relevantReleases = releaseItems.slice(usersPreviousReleasesPosition);
  return (
    <Dialog.Root open={open} onOpenChange={() => setOpen(false)}>
      <Dialog.Content style={{ maxWidth: '60rem', maxHeight: '70vh' }}>
        <Dialog.Title mb="6">
          <Flex align="center" gap="3">
            <Heading size="4">Latest Releases</Heading>
          </Flex>
        </Dialog.Title>

        <Flex direction="column" gap="4" className={Styles.Releases}>
          {relevantReleases.reverse().map((release) => (
            <Flex key={release.id} gap="3">
              <Flex>{getReleaseTypeIcon(release.type)}</Flex>
              <Flex align="start" direction="column" gap="2" width="100%">
                <Flex align="center" justify="between" gap="2" width="100%">
                  {getReleaseType(release.type)}
                  {release.link && (
                    <Flex align="center" gap="1">
                      <Link size="1" href={release.link} target="_blank">
                        {release.linkText}
                      </Link>
                      <TbExternalLink fontSize="1.6rem" color="var(--cyan-11)" />
                    </Flex>
                  )}
                </Flex>
                <Heading size="3">{release.name}</Heading>
                <Text size="2">{release.description}</Text>
              </Flex>
            </Flex>
          ))}
        </Flex>
        <Flex position="absolute" top="3" right="3">
          <Dialog.Close>
            <IconButton variant="ghost" color="gray">
              <TbX />
            </IconButton>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
